import {
  FiMapPin,
  FiCalendar,
  FiUsers,
  FiEye,
  FiSend,
  FiZap,
  FiTruck,
  FiClock,
  FiTag,
} from "react-icons/fi";
import {
  typeLabel,
  formatPrice,
  formatDate,
  STATUS_LABELS,
  STATUS_TONES,
  assetUrl,
} from "../../../utils/missionsApi";
import MissionTypeIcon, { getTypeMeta } from "./MissionTypeIcon";

export function MissionBadges({ mission }) {
  const badges = [];
  if (mission.isUrgent) {
    badges.push(
      <span key="urg" className="pmm-chip pmm-chip--danger pmm-chip--pulse">
        <FiZap size={12} /> URGENT
      </span>
    );
  }
  if (mission.type === "convoyage") {
    badges.push(<span key="convoy" className="pmm-chip pmm-chip--info"><FiTruck size={12} /> Convoyage</span>);
  }
  if (["reparation_jantes", "renovation_jantes", "peinture_jantes"].includes(mission.type)) {
    badges.push(<span key="wheels" className="pmm-chip pmm-chip--brand">Jantes</span>);
  }
  if (["carrosserie_retouche", "carrosserie_petit_choc", "debosselage"].includes(mission.type)) {
    badges.push(<span key="body" className="pmm-chip pmm-chip--warn">Carrosserie</span>);
  }
  if (["nettoyage_interieur", "nettoyage_exterieur", "preparation_vehicule", "polissage_lustrage"].includes(mission.type)) {
    badges.push(<span key="cleaning" className="pmm-chip pmm-chip--info">Nettoyage</span>);
  }
  if (mission.durationType === "multi_jours") {
    badges.push(<span key="multi" className="pmm-chip pmm-chip--neutral">Multi-jours</span>);
  }
  if (mission.date && new Date(mission.date).toDateString() === new Date().toDateString()) {
    badges.push(<span key="today" className="pmm-chip pmm-chip--success"><FiCalendar size={12} /> Aujourd'hui</span>);
  }
  return <div className="pmm-mission-card__badges">{badges}</div>;
}

export default function MissionCard({ mission, onOpen, onApply, showActions = true, dense = false }) {
  const firstPhoto = mission?.photos?.[0]?.url || mission?.beforePhotos?.[0]?.url;
  const tone = STATUS_TONES[mission.status] || "neutral";
  const statusLabel = STATUS_LABELS[mission.status] || mission.status;
  const meta = getTypeMeta(mission.type);

  return (
    <article className={`pmm-mission-card ${mission.isUrgent ? "is-urgent" : ""}`}>
      <div className="pmm-mission-card__head">
        <div style={{ display: "flex", gap: 10, alignItems: "flex-start", minWidth: 0, flex: 1 }}>
          <MissionTypeIcon type={mission.type} size={38} />
          <div style={{ minWidth: 0 }}>
            <h3 className="pmm-mission-card__title">{mission.title}</h3>
            <div className="pmm-mission-card__type">
              <FiTag size={11} style={{ marginRight: 4, verticalAlign: "-1px" }} />
              {typeLabel(mission.type)}
            </div>
          </div>
        </div>
        <span className={`pmm-chip pmm-chip--${tone}`}>{statusLabel}</span>
      </div>

      {!dense && (
        <div className="pmm-mission-card__photo" style={{ background: firstPhoto ? "var(--cream-warm)" : meta.bg }}>
          {firstPhoto ? (
            <img src={assetUrl(firstPhoto)} alt={mission.title} />
          ) : (
            <span style={{ color: meta.tone, fontSize: 40, display: "grid", placeItems: "center" }}>
              <MissionTypeIcon type={mission.type} size={56} />
            </span>
          )}
        </div>
      )}

      <MissionBadges mission={mission} />

      <div className="pmm-mission-card__meta">
        <span><FiMapPin /> <b>{mission.city || "—"}</b></span>
        <span><FiCalendar /> {formatDate(mission.date)}</span>
        <span><FiClock /> <b>{formatPrice(mission.estimatedBudget || 0)}</b></span>
        <span><FiUsers /> {mission.proposalsCount || 0} prop.</span>
      </div>

      {showActions && (
        <div className="pmm-mission-card__actions">
          {onOpen && (
            <button className="pmm-btn pmm-btn--ghost" onClick={onOpen}>
              <FiEye /> Voir la mission
            </button>
          )}
          {onApply && (
            <button className="pmm-btn pmm-btn--primary" onClick={onApply}>
              <FiSend /> Postuler
            </button>
          )}
        </div>
      )}
    </article>
  );
}
